// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2bNqu","content":"ManualTimeModal_content__2JuIc"};